import { hakalotTerms } from "../terms/hakalotTerms";
import { CalculationResult, DegreeType, Faculty, Lang, MiluimPeriod, RightType } from "../types/general";
import { getMomentRange } from "./appUtils";
import { BINARY_COURSES_NUM, PTOR_NEKUDOT_ZCHOOT } from "./config";
import * as config24_25 from './config24-25';
import { Periods } from './config24-25';

const MAX_PTOR_NZ_TERM = "המספר המקסימלי לפטור מנקודות זכות בתואר: ";
const MAX_BIN_COURSE_TERM = "המספר המקסימלי לקורסים עם עובר בינארי בתואר: ";

export function calcRightsAccordingDays24_25(isInMiluim: boolean, degreeType: DegreeType, miluimRanges: MiluimPeriod[]): CalculationResult[] {
    let hakalotArray = [] as CalculationResult[];

    let miluimDaysNumIn24_25 = getOverlappingDaysNum24_25(miluimRanges);
    let overlappingDaysNumSemesterA = getOverlappingDaysNum24_25(miluimRanges, 1);
    let overlappingDaysNumSemesterB = getOverlappingDaysNum24_25(miluimRanges, 2);

    let leftMiluimDaysIn24_25 = miluimDaysNumIn24_25;
    let leftMiluimDaysInSemesterA = overlappingDaysNumSemesterA;
    let leftMiluimDaysInSemesterB = overlappingDaysNumSemesterB;

    if (miluimDaysNumIn24_25 >= 100) {
        let hakalaBin = getHakala(BINARY_COURSES_NUM, degreeType, Periods.IN_YEAR_100_DAYS, hakalotTerms.IN_YEAR_100_DAYS)
        hakalotArray.push(hakalaBin);
    }

    if (overlappingDaysNumSemesterA >= 35) {
        let hakalaNZ = getHakala(PTOR_NEKUDOT_ZCHOOT, degreeType, Periods.IN_ONE_SEMESTER_35_DAYS, hakalotTerms.IN_ONE_SEMESTER_35_DAYS);
        hakalotArray.push(hakalaNZ);

        let hakalaBin = getHakala(BINARY_COURSES_NUM, degreeType, Periods.IN_ONE_SEMESTER_35_DAYS, hakalotTerms.IN_ONE_SEMESTER_35_DAYS);
        hakalotArray.push(hakalaBin);

        leftMiluimDaysIn24_25 = miluimDaysNumIn24_25 - 35;
        leftMiluimDaysInSemesterA = overlappingDaysNumSemesterA - 35;
    }

    if (overlappingDaysNumSemesterB >= 35) {
        let hakalaNZ = getHakala(PTOR_NEKUDOT_ZCHOOT, degreeType, Periods.IN_ONE_SEMESTER_35_DAYS, hakalotTerms.IN_ONE_SEMESTER_35_DAYS);
        hakalotArray.push(hakalaNZ);

        let hakalaBin = getHakala(BINARY_COURSES_NUM, degreeType, Periods.IN_ONE_SEMESTER_35_DAYS, hakalotTerms.IN_ONE_SEMESTER_35_DAYS);
        hakalotArray.push(hakalaBin);

        leftMiluimDaysIn24_25 = miluimDaysNumIn24_25 - 35;
        leftMiluimDaysInSemesterB = overlappingDaysNumSemesterB - 35;
    }


    if (leftMiluimDaysIn24_25 >= 35 || leftMiluimDaysInSemesterA >= 21 || leftMiluimDaysInSemesterB >= 21) {
        let period = Periods.IN_YEAR_35_DAYS;
        let term = hakalotTerms.IN_YEAR_35_DAYS;

        if (leftMiluimDaysInSemesterA >= 21 || leftMiluimDaysInSemesterB >= 21) {
            period = Periods.IN_ONE_SEMESTER_21_DAYS;
            term = hakalotTerms.IN_ONE_SEMESTER_21_DAYS;

            let hakalaHighestGrade = getHakalaWithoutScore(RightType.HighestGrade, term);
            hakalotArray.push(hakalaHighestGrade);
        }

        let hakalaNZ = getHakala(PTOR_NEKUDOT_ZCHOOT, degreeType, period, term);
        hakalotArray.push(hakalaNZ);

        let hakalaBin = getHakala(BINARY_COURSES_NUM, degreeType, period, term);
        hakalotArray.push(hakalaBin);

        if (degreeType === DegreeType.Boger) {
            hakalotArray.push(getHakalaWithoutScore(RightType.AlternativeAssessment, term))
        }
    }

    if (degreeType === DegreeType.Boger && getOverlappingDaysNumByRange(miluimRanges, config24_25.BEFORE_24_25_THREE_MONTHS) > 60) {
        if (!hakalotArray.some(h => h.type === RightType.AlternativeAssessment)) {
            hakalotArray.push(getHakalaWithoutScore(RightType.AlternativeAssessment, hakalotTerms.BEFORE_60_DAYS))
        }
    }

    if (miluimDaysNumIn24_25 >= 100 || overlappingDaysNumSemesterA >= 50 || overlappingDaysNumSemesterB >= 50) {
        let period = Periods.IN_YEAR_100_DAYS;
        let term = hakalotTerms.IN_YEAR_100_DAYS;

        if (leftMiluimDaysInSemesterA >= 21 || leftMiluimDaysInSemesterB >= 21) {
            period = Periods.IN_ONE_SEMESTER_50_DAYS;
            term = hakalotTerms.IN_ONE_SEMESTER_50_DAYS;
        }

        let hakalaNZ = getHakalaWithoutScore(RightType.IntermediateAssignmentsPtor, term);
        hakalotArray.push(hakalaNZ);

        let hakalaBin = getHakalaWithoutScore(RightType.PtorMandatoryAttendance, term);
        hakalotArray.push(hakalaBin);
    }

    if (miluimDaysNumIn24_25 > 28) {
        hakalotArray.push(getHakalaWithoutScore(RightType.TestTimeExtension, hakalotTerms.TWENTY_EIGHT_DAYS_REASON));
        hakalotArray.push(getHakalaWithoutScore(RightType.ExamDoesntCount, hakalotTerms.TWENTY_EIGHT_DAYS_REASON));
    }

    hakalotArray.sort((a, b) => b.type - a.type)
    return hakalotArray;

}


function getOverlappingDaysNum24_25(miluimRanges: MiluimPeriod[], Semester = 0): number {
    var miluimMomentRanges = new Array();
    var sumOfOverlappingDays = 0;

    miluimRanges.forEach(range => {
        miluimMomentRanges.push(getMomentRange(range.from, range.to))
    });

    if (Semester === 0) { // i.e - calc to whole year
        miluimMomentRanges.forEach(momentRange => {
            var overlapRange = momentRange.intersect(config24_25.YEAR_24_25_PERIOD)
            if (overlapRange) {
                sumOfOverlappingDays += overlapRange.diff('days') + 1;
            }
        });
    } else if (Semester === 1) {
        miluimMomentRanges.forEach(momentRange => {
            var overlapRange = momentRange.intersect(config24_25.SEMESTER_A_24_25_PERIOD)
            if (overlapRange) {
                sumOfOverlappingDays += overlapRange.diff('days') + 1;
            }
        });
    } else if (Semester === 2) {
        miluimMomentRanges.forEach(momentRange => {
            var overlapRange = momentRange.intersect(config24_25.SEMESTER_B_24_25_PERIOD)
            if (overlapRange) {
                sumOfOverlappingDays += overlapRange.diff('days') + 1;
            }
        });
    }
    // console.log(sumOfOverlappingDays);
    return sumOfOverlappingDays;
}

export function getOverlappingDaysNumByRange(miluimRanges: MiluimPeriod[], range: any): number {
    var miluimMomentRanges = new Array();
    var sumOfOverlappingDays = 0;

    miluimRanges.forEach(range => {
        miluimMomentRanges.push(getMomentRange(range.from, range.to))
    });

    miluimMomentRanges.forEach(momentRange => {
        var overlapRange = momentRange.intersect(range)
        if (overlapRange) {
            sumOfOverlappingDays += overlapRange.diff('days') + 1;
        }
    });

    return sumOfOverlappingDays;
}

function getHakala(rightType: RightType, degreeType: DegreeType, period: config24_25.Periods, reason: any) {
    let hakalaSum = config24_25.RightsConfig.get(degreeType)!.get(period)!.get(rightType)!;

    let hakala = {
        sum: hakalaSum,
        reason: reason,
        type: rightType,
        is24_25: true
    }
    return hakala;
}

function getHakalaWithoutScore(rightType: RightType, reason: any) {
    let hakala = {
        sum: -1,
        reason: reason,
        type: rightType,
        is24_25: true
    }

    return hakala;
}

function getFinalHakala(hakalotArray: CalculationResult[], degreeType: DegreeType, rightType: RightType, reason: string): CalculationResult {
    let rightTypeArray = [];

    // take max from malag or huji (malag releted only for Boger)
    if (hakalotArray.some(h => h.isGreater)) {
        // if rightType is PTOR_NEKUDOT_ZCHOOT incule also AvneyPina type
        if (rightType === PTOR_NEKUDOT_ZCHOOT) {
            rightTypeArray = hakalotArray.filter(h => (h.type === rightType || h.type === RightType.AvneyPina) && (h.isGreater || h.is24_25));
        } else {
            rightTypeArray = hakalotArray.filter(h => (h.type === rightType) && (h.isGreater || h.is24_25));
        }
    } else {
        if (rightType === PTOR_NEKUDOT_ZCHOOT) {
            rightTypeArray = hakalotArray.filter(h => (h.type === rightType || h.type === RightType.AvneyPina));
        } else {
            rightTypeArray = hakalotArray.filter(h => h.type === rightType);
        }
    }

    let coursesSum = rightTypeArray.reduce((acc, h) => acc + h.sum, 0);

    let maxSum = config24_25.MaxZcootConfig.get(degreeType)!.get(rightType);
    let finalSum = Math.min(coursesSum, maxSum || 0);

    let reasonRecord = {
        [Lang.he]: reason + maxSum,
        [Lang.en]: ""
    }

    let finalHakala = {
        sum: finalSum,
        reason: reasonRecord,
        type: rightType,
        isFinalSum: true
    }

    return finalHakala;
}

export function addFinalHakalot(hakalotArray: CalculationResult[], degreeType: DegreeType): CalculationResult[] {
    // get 2 final hakala for ptorNZ and binCourse
    if (hakalotArray.some(h => h.type === BINARY_COURSES_NUM)) {
        let finalBinCourse = getFinalHakala(hakalotArray, degreeType, BINARY_COURSES_NUM, MAX_BIN_COURSE_TERM);
        hakalotArray.push(finalBinCourse);
    }
    if (hakalotArray.some(h => h.type === PTOR_NEKUDOT_ZCHOOT)) {
        let finalPtorNZ = getFinalHakala(hakalotArray, degreeType, PTOR_NEKUDOT_ZCHOOT, MAX_PTOR_NZ_TERM);
        hakalotArray.push(finalPtorNZ);
    }

    return hakalotArray
}
